// Etichette condivise del pannello admin (pipeline, protocolli, provenienze, slot)

export const PIPELINE_STATUSES = [
  "nuovo_contatto",
  "videoconsulenza_prenotata",
  "videoconsulenza_effettuata",
  "sopralluogo_programmato",
  "sopralluogo_effettuato",
  "proposta_inviata",
  "cliente_acquisito",
  "non_acquisito",
];

export const PIPELINE_LABELS = {
  nuovo_contatto: "Nuovo contatto",
  videoconsulenza_prenotata: "Videoconsulenza prenotata",
  videoconsulenza_effettuata: "Videoconsulenza effettuata",
  sopralluogo_programmato: "Sopralluogo programmato",
  sopralluogo_effettuato: "Sopralluogo effettuato",
  proposta_inviata: "Proposta inviata",
  cliente_acquisito: "Protocollo attivato",
  non_acquisito: "Non acquisito",
};

// Il percorso clienti avanza liberamente senza fasi obbligatorie: il sopralluogo resta facoltativo
// per i protocolli che non lo prevedono e "Protocollo attivato" indica l'effettivo avvio del servizio.
export const PIPELINE_HINT =
  "Il percorso avanza liberamente, senza fasi obbligatorie: il sopralluogo resta facoltativo. «Protocollo attivato» va usato solo quando il servizio è effettivamente partito, non alla semplice prenotazione o videoconsulenza.";

export const PROTOCOL_LABELS = {
  GENERAL: "A.C. HUB Generale",
  AC_START: "AC START",
  AC_HUNT: "AC HUNT",
  AC_SELECT: "AC SELECT",
  AC_INVEST: "AC INVEST",
  AC_MANAGEMENT: "AC MANAGEMENT",
};

export const PROVENANCE_LABELS = {
  hero: "Hero principale",
  "ac-start": "AC START",
  "ac-hunt": "AC HUNT",
  "ac-select": "AC SELECT",
  "ac-invest": "AC INVEST",
  "ac-management": "AC MANAGEMENT",
  altro: "Altro",
};

export const ADMIN_BOOKING_STATUSES = ["confermata", "svolta", "annullata", "no_show", "da_riprogrammare"];

export const ADMIN_BOOKING_STATUS_LABELS = {
  confermata: "Confermato",
  svolta: "Effettuato",
  annullata: "Annullato",
  no_show: "Cliente assente",
  da_riprogrammare: "Da riprogrammare",
};

// Slot 20 minuti identici al backend (09:00-12:40, 15:00-18:40, giorni lavorativi)
export const BOOKING_SLOTS = (() => {
  const slots = [];
  const push = (h, m) => slots.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
  for (let h = 9; h < 13; h++) [0, 20, 40].forEach((m) => push(h, m));
  for (let h = 15; h < 19; h++) [0, 20, 40].forEach((m) => push(h, m));
  return slots;
})();

// Attività commerciali manuali (Fase 1: senza promemoria automatici, arrivano in Fase 2)
// Le tipologie valide per le nuove attività sono 4; le tipologie storiche (richiamo/follow_up)
// restano solo per la visualizzazione dei dati esistenti, senza migrazioni.
export const ACTIVITY_TYPES = ["chiamata", "email", "sopralluogo", "altro"];
export const ACTIVITY_TYPE_LABELS = {
  chiamata: "Chiamata",
  email: "Email",
  sopralluogo: "Sopralluogo",
  altro: "Altro",
  richiamo: "Chiamata",
  follow_up: "Ricontattato",
};
export const ACTIVITY_STATUS_LABELS = {
  aperta: "Da fare",
  completata: "Completata",
  annullata: "Annullata",
};

export const EVENT_TYPE_LABELS = {
  contatto_creato: "Contatto",
  richiesta: "Richiesta",
  prenotazione: "Prenotazione",
  fase: "Fase",
  nota: "Nota",
  attività: "Attività",
  amministrativo: "Archivio",
};

export const todayIso = () => new Date().toLocaleDateString("en-CA");
